<script lang="ts">
  import { projectStore } from '$lib/state/project.svelte';
  import { computeStatus } from '$lib/compute/recompute.svelte';
  import { walkLeaves } from '$lib/model/tree';
  import {
    lpiCeiling,
    pixelDimensions,
  } from '$lib/compute/settings-utils';
  import { computeTiles } from '$lib/compute/tiling';

  const dims = $derived(pixelDimensions(projectStore.settings));
  const cap = $derived(lpiCeiling(projectStore.settings));
  const leafCount = $derived.by(() => {
    const leaves = walkLeaves(projectStore.pipeline);
    return leaves.filter((l) => l.preview?.enabled !== false).length;
  });
  const totalLeaves = $derived(walkLeaves(projectStore.pipeline).length);
  const tileGrid = $derived(computeTiles(projectStore.settings));
</script>

<footer class="bar">
  <span class="cell">
    {projectStore.settings.target_width} × {projectStore.settings.target_height}
    {projectStore.settings.units}
  </span>
  <span class="sep"></span>
  <span class="cell mono">{dims.width}×{dims.height}px @ {projectStore.settings.dpi}dpi</span>
  <span class="sep"></span>
  <span class="cell">LPI ceiling <strong>{cap}</strong></span>
  <span class="sep"></span>
  <span class="cell">
    Layers <strong>{leafCount}</strong>{#if totalLeaves !== leafCount}
      <span class="dim">/ {totalLeaves}</span>{/if}
  </span>
  {#if tileGrid.tiles.length > 1}
    <span class="sep"></span>
    <span class="cell">
      Tiles <strong>{tileGrid.cols}×{tileGrid.rows}</strong>
    </span>
  {/if}
  <span class="spacer"></span>
  {#if computeStatus.running}
    <span class="cell running">computing…</span>
  {:else if computeStatus.lastSourceHash}
    <span class="cell mono dim">
      {computeStatus.lastSourceHash.slice(0, 7)}
    </span>
  {/if}
</footer>

<style>
  .bar {
    grid-area: status;
    display: flex;
    align-items: center;
    gap: var(--gap-m);
    padding: 0 var(--gap-l);
    background: var(--surface);
    border-top: 1px solid var(--border);
    font-size: 11px;
    color: var(--text-dim);
    font-family: var(--font-mono);
    height: 24px;
  }
  .cell {
    white-space: nowrap;
  }
  .cell strong {
    color: var(--text);
    font-weight: 600;
  }
  .mono {
    font-family: var(--font-mono);
  }
  .dim {
    opacity: 0.6;
  }
  .sep {
    width: 1px;
    height: 14px;
    background: var(--border);
  }
  .spacer {
    flex: 1;
  }
  .running {
    color: var(--accent);
  }
</style>
